import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function AuthRoute({ component: Component, ...rest }) {
  let authed = false;

  if (!window.sessionStorage.accessToken) {
    authed = false;
  } else {
    authed = true;
  }

  return (
    <Route
      {...rest}
      render={props =>
        authed === true ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
  );
}



// WEBPACK FOOTER //
// ./src/auth/AuthRoute.js